import axios from "axios";
import apiInstance from "../api/api";
import authHeader from "../helpers/header";
import helper from "../helpers/query";
import { API_URL, EXCLUDE_TAGS, NODE_URL } from "../configs";

// Create new collection
const createNewCollection = (data) => {
  return apiInstance.post(
    `collections/`,
    { data },
    { headers: authHeader(), withCredentials: true }
  );
};

// get collection detail by collection id
const getCollectionById = (id) => {
  console.log("[collectionAPI] Using apiInstance for getCollectionById");
  return apiInstance.get(`collections/by_id/${id}`, { headers: authHeader(), withCredentials: true });
};

/**
 * Remove a collection by ID (updating status to 'deleted').
 *
 * This async function sends a DELETE request to the FastAPI backend to mark
 * a collection as 'deleted'. The collection ID is passed as a parameter, and the
 * function returns the result of the API call.
 *
 * @param {string} id - The ID of the collection to be deleted.
 * @returns {Object} - The response data from the API.
 * @throws {Error} - Throws an error if the API request fails.
 */
const removeCollection = async (id) => {
  try {
    // Construct the API URL using the collection ID
    const url = `collections/${id}`;
    // Send a DELETE request to the API and await the response
    const response = await apiInstance.delete(url, { headers: authHeader(), withCredentials: true });
    return response;
  } catch (error) {
    // Handle any errors that occur during the request
    console.error('Error deleting collection:', error);
    throw error;  // Propagate the error so it can be handled by the caller
  }
};

// update collection data
const updateCollection = (id, data) => {
  console.log(data.tags.split(','));
  let arr_tags = [];
        //process tags data
        for (let i = 0; i < data.tags.split(',').length; i++) {
            //exclude unuse words
            if (!EXCLUDE_TAGS.includes(data.tags.split(',')[i].trim())) {
                arr_tags.push({
                    name: data.tags.split(',')[i].trim().replace(/[^\w\s]/gi, "")
                });
            }
        }
        return apiInstance.patch(API_URL + `collections/${id}`, {
            collection_name: data.collection_name,
            resources: data.resources,
            status: data.status,
            slug: data.slug,
            private: data.private,
            tags: arr_tags
        }, { headers: authHeader(), withCredentials: true });
};

// get collection 's resources by collection id
const getResourceFromCollection = (id) => {
  console.log("[collectionAPI] Using apiInstance for getResourceFromCollection");
  return apiInstance.get(`collections/resources_from/${id}`, { headers: authHeader(), withCredentials: true });
};

// get list of collection contain resources
const getCollectionHasResource = (resource_id) => {
  console.log("[collectionAPI] Using apiInstance for getCollectionHasResource");
  return apiInstance.get(`collections/has_resource/${resource_id}`, { headers: authHeader(), withCredentials: true });
};

const getCollectionsByQuery = (query) => {
  //build query
  let newQuery = {};

  if (query.q) {
    newQuery.q = query.q;
  }

  if (query.created_by) {
    newQuery.created_by = query.created_by;
  }

  if (query.created_from) {
    newQuery.created_from = query.created_from;
  }

  if (query.created_to) {
    newQuery.created_to = query.created_to;
  }

  if (query.status) {
    newQuery.status = query.status;
  }

  if (query.page) {
    newQuery.offset = parseInt(query.page);
  }

  if (query.pageSize) {
    newQuery.limit = parseInt(query.pageSize);
  }

  if (query.sortby) {
    newQuery.sortby = query.sortby;
  }

  if (query.direction) {
    newQuery.direction = query.direction;
  }
 
  let q = helper.arrayToQueryString(newQuery);
  return axios.get(NODE_URL + `api/be/collections/?${q}`, { headers: authHeader(), withCredentials: true });
};

// Fetch collections with optional query parameters
const getAllCollections = async (query) => {
  let newQuery = {};

  if (query.status) newQuery.status = query.status;
  if (query.private !== undefined) newQuery.private = query.private;
  if (query.owner) newQuery.owner = query.owner;
  if (query.search) newQuery.search = query.search;
  if (query.pageSize) newQuery.limit = query.pageSize;
  if (query.page) newQuery.offset = parseInt(query.page)-1;
  if (query.sortby) newQuery.sortby = query.sortby;
  if (query.direction) newQuery.direction = query.direction;

  let q = helper.arrayToQueryString(newQuery);
  console.log("[collectionAPI] Using apiInstance for getAllCollections", q);
  const response = await apiInstance.get(`collections/?${q}`, {
    headers: authHeader(),
    withCredentials: true,
  });

  return response.data;
};

const bulkUpdateCollections = (data) => {
  console.log("[collectionAPI] Using apiInstance for bulkUpdateCollections", data);
  return apiInstance.patch(
    `collections/bulk_update/`,
    data,
    { headers: authHeader(), withCredentials: true }
  );
};


// Add resources to a collection
const addResourcesToCollection = async (collection_id, resource_ids) => {
  try {
    const res = await apiInstance.post(
      `collections/addResources`,
      {
        data: {
          resource_ids,
          collection_id,
        },
      },
      {
        headers: authHeader(),
        withCredentials: true,
      }
    );
    return res.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Not logged in
      throw new Error("Not authenticated. Please login again.");
    }
    if (error.response && error.response.status === 404) {
      throw new Error("Collection not found.");
    }
    throw error;
  }
};

// Remove resources from a collection
const removeResourcesFromCollection = async (collection_id, resource_ids) => {
  try {
    const res = await apiInstance.post(
      `collections/removeResources`,
      {
        data: {
          resource_ids,
          collection_id,
        },
      },
      {
        headers: authHeader(),
        withCredentials: true,
      }
    );
    return res.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Not logged in
      throw new Error("Not authenticated. Please login again.");
    }
    throw error;
  }
};


const exportedObject = {
  createNewCollection,
  getCollectionById,
  updateCollection,
  removeCollection,
  getResourceFromCollection,
  getCollectionHasResource,
  getCollectionsByQuery,
  getAllCollections, // Add fetchCollections to the exported object
  bulkUpdateCollections,
  addResourcesToCollection,
  removeResourcesFromCollection,
};

export default exportedObject;
